/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Insights_Col_Fund1Inputs */

const en_coinvestments_insights_col_fund1 = /** @type {(inputs: Coinvestments_Insights_Col_Fund1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fund`)
};

/**
* | output |
* | --- |
* | "Fund" |
*
* @param {Coinvestments_Insights_Col_Fund1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_insights_col_fund1 = /** @type {((inputs?: Coinvestments_Insights_Col_Fund1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Insights_Col_Fund1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_insights_col_fund1(inputs)
});
export { coinvestments_insights_col_fund1 as "coInvestments_insights_col_fund" }